import { useRef } from 'react';
import { Button } from '@zillow/constellation-10';
import { IconPlusFilled } from '@zillow/constellation-icons';
import { ACCEPTED_FILE_EXTENSIONS } from '../../../../../hooks/useIncomeDocumentUploads';

type Props = {
  label: string;
  onFiles: (files: Array<File>) => void;
};

export function AddFilesButton({ label, onFiles }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <Button
        type="button"
        tone="brand"
        emphasis="outlined"
        size="sm"
        icon={<IconPlusFilled />}
        iconPosition="end"
        aria-label={label}
        css={{ flexShrink: 0 }}
        onClick={() => inputRef.current?.click()}
      >
        Add files
      </Button>
      <input
        ref={inputRef}
        type="file"
        multiple
        hidden
        accept={ACCEPTED_FILE_EXTENSIONS.join(',')}
        aria-label={label}
        onChange={(event) => {
          onFiles([...(event.target.files ?? [])]);
          event.target.value = '';
        }}
      />
    </>
  );
}
